import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import RegistrationPage from "./pages/RegistrationPage";
import Footer from "./components/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import ReturnPolicy from "./pages/ReturnPolicy";
import CancellationPolicy from "./pages/CancellationPolicy";
import TermsConditions from "./pages/TermsConditions";
import WhatsAppButton from "./components/WhatsAppButton";
import CourseDetail from "./pages/CourseDetail";
import PaymentResult from "./pages/PaymentResult";

import BookDemoPage from "./pages/BookDemoPage";
import CalendlyDemoPage from "./pages/CalendlyDemoPage";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Courses from "./pages/Courses";
import YoutubeContactPage from "./pages/YoutubeContactPage";

import ScrollToTop from "./components/ScrollToTop";

// Helper component to redirect any legacy hash URLs (e.g. /#/courses -> /courses)
const LegacyHashRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (window.location.hash && window.location.hash.startsWith("#/")) {
      const targetPath = window.location.hash.substring(1); // remove #
      navigate(targetPath, { replace: true });
    }
  }, [navigate, location]);

  return null;
};

function App() {
  return (
    <Router>
      <LegacyHashRedirect />
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/online-skill-development-courses-india" element={<About />} />
          <Route path="/register" element={<RegistrationPage />} />

          {/* Dynamic Course Route supporting both Slug and ID */}
          <Route path="/course/:slugOrId" element={<CourseDetail />} />

          {/* Dedicated High-Intent Landing Page Routes */}
          <Route path="/best-digital-marketing-course-online-india-with-certificate" element={<CourseDetail seoSlug="best-digital-marketing-course-online-india-with-certificate" />} />
          <Route path="/best-graphic-design-course-online-india-with-certificate" element={<CourseDetail seoSlug="best-graphic-design-course-online-india-with-certificate" />} />
          <Route path="/best-video-editing-course-online-india-with-certificate" element={<CourseDetail seoSlug="best-video-editing-course-online-india-with-certificate" />} />

          <Route path="/get-in-touch-skill-ascent" element={<Contact />} />
          <Route path="/youtube-contact" element={<YoutubeContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />

          <Route path="/payment-result" element={<PaymentResult />} />
          <Route path="/book-demo" element={<BookDemoPage />} />
          <Route path="/calendly-demo" element={<CalendlyDemoPage />} />

          {/* Catch-all fallback */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <WhatsAppButton />
      <Footer />
    </Router>
  );
}

export default App;

